export const timeoutPromise = (ms: number, message?: string) =>
  new Promise((_, reject) => {
    setTimeout(() => reject(message ?? "Timeout reached"), ms);
  });
